function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m334.9 218.1c-.5.3-18.3-2.7-40.7-4.2-18.2-1.2-39.5-1.2-56.7 0-14 .9-32.4-6.1-34.6 2.3-8.2 31.4-26 58.7-48.5 79.9-17 16-36.4 28.1-57.4 35.6-25-12.8-36.8-41.4-26.2-66.4 8.4-19.9 18.3-41.7.1-46.7-13.2-3.6-20.5 9-25.5 22.5-9.7 25.9-28.2 52.7-33.5 84.5-5.6 33.5 0 69.1 29 89.3 67.6 46.8 140.9-29 218.2-48.1 28-6.9 58.8-5.8 83.5-20.1 18.5-10.7 30.8-28.5 34.2-48.5 5.6-32.2-11.1-64.1-41.9-80.1z",
  fill: "#5bc0be",
  stroke: "#5bc0be",
  strokeWidth: 20
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m202.9 216.2c-8.2 31.4-26 58.7-48.5 79.9-17 16-36.4 28.1-57.4 35.6-25-12.8-36.8-41.4-26.2-66.4 8.4-19.9 18.3-41.7.1-46.7-13.2-3.6-20.5 9-25.5 22.5-9.7 25.9-28.2 52.7-33.5 84.5-5.6 33.5 0 69.1 29 89.3 67.6 46.8 140.9-29 218.2-48.1 28-6.9 58.8-5.8 83.5-20.1 18.5-10.7 30.8-28.5 34.2-48.5 5.6-32.1-11.1-64.1-41.9-80",
  fill: "none",
  stroke: "#5bc0be",
  strokeWidth: 20
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m264.9 91.2 54.3 110.8 65.1-192h-239l65 191.6z",
  fill: "#5bc0be"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m264.9 91.2 54.3 110.8 65.1-192h-239l65 191.6z",
  fill: "none",
  stroke: "#5bc0be",
  strokeWidth: 20
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 199,
  cy: 216.6,
  fill: "#5bc0be",
  r: 40.9
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  stroke: "#5bc0be",
  strokeWidth: 20
}, /*#__PURE__*/React.createElement("circle", {
  cx: 199,
  cy: 216.6,
  fill: "none",
  r: 40.9
}), /*#__PURE__*/React.createElement("circle", {
  cx: 332.4,
  cy: 216.6,
  fill: "#5bc0be",
  r: 40.9
}), /*#__PURE__*/React.createElement("circle", {
  cx: 332.4,
  cy: 216.6,
  fill: "none",
  r: 40.9
}));

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 65.1,
  cy: 216.9,
  fill: "#5bc0be",
  r: 40.9
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 65.1,
  cy: 216.9,
  fill: "none",
  r: 40.9,
  stroke: "#5bc0be",
  strokeWidth: 20
});

var SvgJest = function SvgJest(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 398.3 439.9",
    viewBox: "0 0 398.3 439.9",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jest.88d83e84.svg";
export { ForwardRef as ReactComponent };